import React, { useState } from 'react';
import { Field, FieldProps } from 'formik';

import { EyeClose, EyeOutline } from '@lyearn/icons';
import { Input, LinkButton } from '@lyearn/ui';

import { FormElementProps, FormEmailField } from '../../../types';

const PasswordFieldInput = (
  props: FormElementProps<FormEmailField> & { fieldProps: FieldProps<string> },
) => {
  const {
    className,
    field,
    fieldProps: {
      field: { value, onBlur, onChange },
      meta: { error, touched },
    },
  } = props;
  const [showPassword, toggleShowPassword] = useState(false);

  return (
    <Input
      className={className}
      disabled={field.disabled}
      endAdornment={
        <LinkButton
          aria-label="toggle password visibility"
          className="py-2 px-4 outline-none -me-10 hover:bg-transparent shrink-0"
          color={'internal'}
          onClick={() => toggleShowPassword(!showPassword)}>
          {showPassword ? (
            <EyeOutline className="h-26 w-26 text-text-placeholder xs:h-24 xs:w-24 xs:text-icon-placeholder" />
          ) : (
            <EyeClose className="h-26 w-26 text-text-placeholder xs:h-24 xs:w-24 xs:text-icon-placeholder" />
          )}
        </LinkButton>
      }
      error={!!(touched && error)}
      name={field.name}
      placeholder={field.placeholder}
      size={field.size}
      type={showPassword ? 'text' : 'password'}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
    />
  );
};

const PasswordField = (props: FormElementProps<FormEmailField>) => {
  const { field } = props;

  return (
    <Field name={field.name}>
      {(fieldProps: FieldProps<string>) => (
        <PasswordFieldInput {...props} fieldProps={fieldProps} />
      )}
    </Field>
  );
};

export default PasswordField;
